'use strict';

function ChangeEmail() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [_ErrorController];
  this.loadedVerifySection = false;

  this._baseClassName = 'form-wizard__section';
  this.url = window.location.href;
  this.states = {
    passive: this._baseClassName + '--passive',
    edit: this._baseClassName + '--edit',
    change: this._baseClassName + '--change',
    summary: this._baseClassName + '--summary'
  };

  this.init = function () {
    // location.referred
    this.formSection = $('#ChangeEmail__form', this.node);
    this.verifySection = $('#ChangeEmail__verify', this.node);
    this.emailUpdateSection = $('#ChangeEmail__form_new_email', this.node);
    this.editIconEmail = $('#ChangeEmail__form a.icon--edit', this.node);
    this.newEmail = $('#new_email', this.node);
    this.currentPassword = $('#current_password', this.node);
    this.notifications = $('#Notification');

    // Callbacks
    this._submitEmailCallback = this.presenter.addCallbackToAction('account.edit_account', $.proxy(this._onSubmitNewEmail, this));

    // Event listeners
    this.editIconEmail.on('click', this._pageView.bind(this, 'validated-edit'));

    // Check if Email is Verified
    this._onEmailVerified();
  };

  this.initAllReady = function () {
    this.analytics.pushEvent('change-email', { ChangeEmail: ['Required'] });
    this.analytics.pushEvent('virtual-page-view');
  };

  this._onEmailVerified = function () {
    if (this.url.indexOf('change-email-verified') > -1) {
      this._pageView('email-validated');
    }
  };

  this._onSubmitNewEmail = function (data, response) {
    var _currentEmail = this.presenter.models.account.email_address;
    var _newEmail = this.formSection.find('#ChangeEmail__form_new_email #new_email').val();
    if (_currentEmail === _newEmail) {
      this.formSection.find('#ChangeEmail__form_new_email').mogo().setErrorForValidationField('email_address', 'This is already your email. Choose a new email address');
    } else if (response === 200) {
      var updatedModel = $.extend(true, {}, this.presenter.models.account, data);
      this.presenter.updateModel('account', updatedModel, $.proxy(this._pageView, this, 'email-updated'));
      var formAnalyticsID = $('form', this.node).data('analytics-id');
      this.analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });
    } else if (response == 401 && data.errors[0].key == 'incorrect_email_address_or_password') {
      this.analytics.forcePushEvent('form-errors', {
        FormErrors: ['new_email', 'current_password']
      });
    } else if (response == 403 && (data.errors[0].key == 'member_service_unauthorized' || data.errors[0].key == 'unauthorized')) {
      this.analytics.forcePushEvent('form-errors', { FormErrors: ['current_password'] });
      // TODO: remove showErrorLabel logic and pass in error messages as parameters. Need backend fix to return correct "property" value
      this.formSection.find('#ChangeEmail__form_new_email').mogo().setErrorForValidationField('password', "That does't look like a valid password. Try again?");
    } else if (this.isGeneralConnectionIssue(data, response)) {
      this.invokeConnectionIssuePage($('#ChangeEmail__form_new_email', this.node)[0], {
        productLabel: 'MogoMember'
      });
    } else {
      this.analytics.forcePushEvent('form-errors', { FormErrors: ['new_email'] });
      var key = data.errors[0].key;

      var invalidEmail = key == 'json_schema_error_did_not_match_all_of' && data.errors[0].msg == 'Provided email does not have a valid format';
      if (response == 400 && !invalidEmail && key != 'member_service_email_taken' && key != 'member_service_service_errors_email_taken') {
        this.notifications.mogo().get();
      }
    }
  };

  this._pageView = function (view) {
    if (view === 'email-updated') {
      // update the view
      this._email_address = this.presenter.models.account.unconfirmed_email ? this.presenter.models.account.unconfirmed_email : this.presenter.models.account.email_address;
      $('.email', this.node).text(this._email_address);
      // display verify account dialog in page
      if (!this.loadedVerifySection) {
        this._loadVerifyEmail();
        this.loadedVerifySection = true;
      }
      this._changeState(this.formSection, this.states.summary);
      this._changeState(this.verifySection, this.states.edit);
    } else if (view === 'email-validated') {
      this._email_address = this.presenter.models.account.unconfirmed_email ? this.presenter.models.account.unconfirmed_email : this.presenter.models.account.email_address;
      $('.email', this.node).text(this._email_address);
      this._changeState(this.formSection, this.states.summary);
      this._changeState(this.verifySection, this.states.summary);
    } else if (view === 'validated-edit') {
      // clear email field once submitted
      this.newEmail.mogo().val('');
      this.currentPassword.mogo().val('');
      this._changeState(this.formSection, this.states.change);
      this._changeState(this.verifySection, this.states.passive);
    } else {
      console.error(view + ' is an invalid view');
    }
  };

  this._loadVerifyEmail = function () {
    $('.change-email__verify').load('/member/account/verify-account.html', $.proxy(function () {
      $(".change-email__verify [data-mogo-page='VerifyAccount']").mogo().create('VerifyEmail', { presenter: this.presenter, analytics: this.analytics }, 'page');
    }, this));
  };

  this._changeState = function (element, newState) {
    var elementState = element.attr('class');
    if (elementState != newState) {
      element.switchClass(elementState, newState);
    }
  };

  this.destroy = function () {
    this.presenter.removeCallbackFromAction('account.edit_account', this._submitEmailCallback);
    this.editIconEmail.off('click');
  };
}